import { deepCopy } from "utils/memo/deepCopy";
import { IData } from "hooks/useGetData";

export const updateSingle = (prev: IData<any>, itemId: number, property: { [key: string]: any }): IData<any> => {
    const prevCopy = deepCopy(prev);

    return { ...prevCopy, data: prevCopy.data.map((item) => (item.id == itemId ? { ...item, ...property } : item)) };
};
